import { Alert, Snackbar, SnackbarOrigin } from "@mui/material";

import type { SnackbarState } from "@/components/FormEngine/hooks/useSnackbar";

type Props = {
  state: SnackbarState;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  autoHideDuration?: number;
  anchorOrigin?: SnackbarOrigin;
};

export const SnackbarComponent = ({
  state,
  onClose,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
}: Props) => (
  <Snackbar
    open={state.open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={anchorOrigin}
    sx={{ zIndex: (t) => (t.zIndex?.snackbar ?? 1400) + 1 }}
  >
    <Alert
      onClose={onClose}
      severity={state.severity}
      variant='filled'
      sx={{ width: "100%" }}
    >
      {state.message}
    </Alert>
  </Snackbar>
);
